export function capitalizeFirstLetter(string) {
  return string && string.charAt(0).toUpperCase() + string.slice(1);
}

export function capitalizeFirstLetterOtherSmall(string) {
  return (
    string && string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
  );
}

export function dataURLtoFile(dataurl, filename) {
  // console.log(dataurl);
  var arr = dataurl.split(",");
  let mime = arr[0].match(/:(.*?);/)[1];
  var bstr = window.atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  console.log("inside data URL");

  var textFileAsBlob = new Blob([u8arr], { type: mime });
  try {
    return new File([u8arr], filename, { type: mime });
  } catch (err) {
    return window.navigator.msSaveBlob(textFileAsBlob, filename);
  }
}

export const randomId = function(length = 6) {
  return Math.random()
    .toString(36)
    .substring(2, length + 2);
};

/**
 * Rounds all decimal percentages in a text string to whole numbers
 * @param {string} text - Text containing percentages (e.g., "45.67% of users")
 * @returns {string} - Text with rounded percentages (e.g., "46% of users")
 * @example
 * roundPercentagesInText("Sales increased by 23.456%") // "Sales increased by 23%"
 * roundPercentagesInText("Growth: 45.8%, Retention: 89.2%") // "Growth: 46%, Retention: 89%"
 */
export const roundPercentagesInText = (text) => {
  if (!text) return text;
  // Match percentages in format: number.decimal%
  // Replace decimal percentages with rounded whole numbers
  return text.replace(/(\d+\.\d+)%/g, (match, number) => {
    return Math.round(parseFloat(number)) + '%';
  });
};

/**
 * Removes paragraph tags from HTML string while keeping the content
 * @param {string} htmlString - HTML string that may contain <p> tags
 * @returns {string} - String with <p> tags removed
 * @example
 * stripParagraphTags("<p>Hello</p>") // "Hello"
 * stripParagraphTags("<p>Option A</p>") // "Option A"
 */
export const stripParagraphTags = (htmlString) => {
  if (!htmlString) return "";
  // Remove opening and closing p tags, keeping the content
  return htmlString.replace(/<\/?p[^>]*>/g, "");
};

/**
 * Strips a leading markdown "# Summary" or plain "Summary" heading from API-returned
 * summary text so it doesn't duplicate the modal title.
 * @param {string} text - Raw summary text from the API
 * @returns {string} - Summary text without the redundant heading
 * @example
 * cleanSummaryText("# Summary\nSome content") // "Some content"
 * cleanSummaryText("Summary\nSome content")   // "Some content"
 */
export const cleanSummaryText = (text) => {
  if (!text) return text;
  return text.replace(/^#?\s*summary\s*\n?/i, '').trimStart();
};
